import React, { useMemo } from 'react';
import TableCellRenderer from './TableCellRenderer';

// Filters columns based on dependsOn + showWhen / hideWhen conditions
const resolveColumns = (columns: any[], conditions: any) =>
  columns.filter((col) => {
    if (!col.dependsOn) return true; // column always visible if no dependency
    const value = conditions[col.dependsOn]; // read condition value
    if (col.showWhen !== undefined) return value === col.showWhen; // show only when condition matches
    if (col.hideWhen !== undefined) return value !== col.hideWhen; // hide only when condition matches
    return true;
  });

const DynamicTable = (props: any) => {
  const { columns, data, translations, conditions = {}, sortDirection = {}, onSort, ...rest } = props; // rest contains helper, handlers, flags etc.

  // Memoized visible columns based on conditions
  const visibleColumns = useMemo(() => resolveColumns(columns, conditions), [columns, conditions]);

  return (
    <table>
      <thead>
        <tr>
          {visibleColumns.map((col: any) => (
            <th key={col.key} className={col.thClass || ''}>
              {col.isCheckbox ? ( // header checkbox (select all)
                <input type="checkbox" checked={props.isAllSelected} onChange={(e) => props.handleSelectAll?.(e.target.checked)} style={{ cursor: 'pointer' }} />
              ) : col.isHtml ? ( // HTML labels support
                <span dangerouslySetInnerHTML={{ __html: col.label || col.key }} />
              ) : (
                col.label || col.key // normal text label
              )}
              {col.sortable && ( // sortable column icon
                <i className={`ic-sort-${sortDirection[col.sortKey || col.key] || 'desc'}`} style={{ cursor: 'pointer', marginLeft: 6 }} onClick={() => onSort?.(col.sortKey || col.key)} />
              )}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {data?.length ? (
          data.map((row: any, rowIndex: number) => (
            <tr key={rowIndex}>
              {visibleColumns.map((col: any) => (
                <td key={col.key} className={col.tdClass || ''} title={col.titleKey ? row[col.titleKey] : undefined} style={col.tdStyle}>
                  <TableCellRenderer row={row} column={col} translations={translations} conditions={conditions} {...rest} />
                </td>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={visibleColumns.length} style={{ textAlign: 'center' }}>
              {translations.commonMsg?.['No data found'] || translations.commonMsg?.loading}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default DynamicTable;
